import React, { useContext, useEffect } from "react";

import axios from "axios";
import { UiToast } from "@ask-christee/ui-response";
import { useNavigate, useSearchParams } from "react-router-dom";

import { PageLoader } from "../../components/molecules";
import { VERIFY_USER_EMAIL } from "../../config";
import { CurrentUserProviderContext } from "../../contexts";

import { setAuthenticationInfo } from "./helpers";

export const ConfirmEmail = () => {
  const { loadCurrentUser } = useContext(CurrentUserProviderContext);

  const navigate = useNavigate();
  const [query] = useSearchParams();

  useEffect(() => {
    const resolveConfirmation = ({ notifyType, message }) => {
      UiToast[notifyType](message);
      navigate("/welcome-to-platform");
    };

    const confirmEmail = async ({ username, code }) => {
      try {
        const res = await axios.patch(VERIFY_USER_EMAIL, {
          username,
          code,
        });
        if (res) {
          setAuthenticationInfo({
            authenticationResult: res.data.AuthenticationResult,
            username,
          });

          await loadCurrentUser();

          resolveConfirmation({
            notifyType: "success",
            message: "Your email has been verified!",
          });
        }
      } catch (error) {
        const errorMessage = error?.response?.data || error.message;
        resolveConfirmation({
          notifyType: "error",
          message: errorMessage,
        });
      }
    };

    const code = query.get("code");
    const username = query.get("username");

    if (!code || !username) {
      navigate("/login");
    } else {
      confirmEmail({ username, code });
    }
  }, [loadCurrentUser, navigate, query]);

  return <PageLoader text="Verifying email..." />;
};
